import api from "../../../api/axiosInstance";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Alert from "react-bootstrap/Alert";
const ExecuteCanvasUserLogin = () => {
    const navigate = useNavigate();
    const [disableExecute, setDisableExecute] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [executeCanvasCourses, setExecuteCanvasCourses] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [selectedOperatorId, setSelectedOperatorId] = useState(0);
    const [operators, setOperators] = useState([])
    // On file select (from the pop up)
    const onFileChange = (event) => {
      // Update the state
      if(event.target.files.length > 0){
          setSelectedFile(event.target.files[0]);
      }else{
          setSelectedFile(null)
      }
  
    };
  
    // On file upload (click the upload button)
    const onFileUpload = () => {
      if(selectedFile == ""){
          toast.error("Choose a file before you execute");
          return;
      }
      setExecuteCanvasCourses(1);
      setDisableExecute(true);
      // Create an object of formData
      const formData = new FormData();
  
      // Update the formData object
      formData.append("file", selectedFile, selectedFile.name);
  
      // Request made to the backend api
      // Send formData object
      var config = {
        method: "post",
        url: process.env.REACT_APP_API_URL + "File/FileUpload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
  
      api(config).then(function (response) {
        if (response.status === 200) {
            ExecuteCanvasCourses(response.data);
        }
      });
    };
  
    const ExecuteCanvasCourses = (excelName) => {
      setExecuteCanvasCourses(2);
      var config = {
        method: "post",
        url:
          process.env.REACT_APP_API_URL +
          "CanvasUsers/ExecueCanvasLastLoginUsers/" +
          excelName,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
  
      api(config)
        .then(function (response) {
          if (response.data.statusCode === 200) {
            setDisableExecute(false);
            setExecuteCanvasCourses(3); //Status Changed to Done
            toast.success("Executed");
          } else {
            setExecuteCanvasCourses(4);
            toast.error(response.data.message);
            setDisableExecute(false);
          }
        })
        .catch(function (error) {
          setExecuteCanvasCourses(4); //Status Changed to Done
          if (error.response.status === 401) {
            localStorage.clear();
            navigate("/login");
            window.location.reload();
          }
        });
    };
  
    useEffect(() => {
      const getOperators = () =>{
          var config = {
              method: "Get",
              url: process.env.REACT_APP_API_URL + "Operators/GetOperators/",
              headers: {
                "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              },
            };
      
            api(config)
              .then(function (response) {
                if (response.data.statusCode === 200) {
                  setOperators(response.data.content);
                }
              })
              .catch(function (error) {
                if (error.response.status === 401) {
                  localStorage.clear();
                  window.location = "/Login";
                  window.location.reload();
                }
              });
      }
      getOperators();
    }, []);
    return ( <>
                 <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Upload Excel - last_user_access-Checking.csv
                </h3>
                <div className="align-self-center">
                  <Link
                    to={"/Settings"}
                    className="btn btn-sm btn-secondary mr-5 cts-btn-secondary"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-sm btn-primary cts-btn-primary"
                    onClick={() => onFileUpload()}
                    disabled={disableExecute}
                  >
                    Execute
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h6>
                      File Selected:{" "}
                      {selectedFile === ""
                        ? "No file selected yet"
                        : selectedFile.name}
                    </h6>
                    <input
                      type="file"
                      className="dropzone custom-file-input"
                      onChange={(e) => onFileChange(e)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>
                              <h6>Excel Sheet Name</h6>
                            </th>
                            <th>
                              <h6>Status</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>last_user_access-Checking.csv</td>
                            <td>
                              {executeCanvasCourses === 0 && (
                                <div className="btn btn-primary btn-sm">
                                  Waiting
                                </div>
                              )}
                              {executeCanvasCourses === 1 && (
                                <div className="btn btn-warning btn-sm">
                                  Uploading
                                </div>
                              )}
                              {executeCanvasCourses === 2 && (
                                <div className="btn btn-warning btn-sm">
                                  In Progress
                                </div>
                              )}
                              {executeCanvasCourses === 3 && (
                                <div className="btn btn-success btn-sm">
                                  Done
                                </div>
                              )}
                              {executeCanvasCourses === 4 && (
                                <div className="btn btn-danger btn-sm">
                                  Failed
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </> );
}
 
export default ExecuteCanvasUserLogin;